<template>
    <div class="container-fluid px-0 pb-5">
        <!-- Nav buttons (Tablets and desktop) -->
        <NavButtons light-btns></NavButtons>

        <!-- Hero -->
        <div class="row m-0 flex-column gap-4 justify-content-center align-items-center mb-3"
            :class="width < 768 ? 'mt-5' : ''">
            <div class="col-12 col-md-9 col-xxl-7 d-flex flex-column gap-3 text-center landing-container-mw">
                <!-- Title and description -->
                <h1 class="landing-title">Your go-to community for medication and health</h1>
                <p>Explore user reviews, compare medications and discover unique connections.</p>
            </div>

            <div class="col-12 col-md-7 col-lg-6 col-xxl-4 landing-container-mw">
                <!-- Search -->
                <Search class="text-body"></Search>
                <!-- Categories list -->
                <Swiper class="gap-4 my-4 in-page-swiper" tag="div" v-if="width < 768">
                    <template #content>
                        <a class="landing-icon gap-2 cursor-pointer" v-for="category in categories"
                            v-load-page="category.route" v-ripple="'i'">
                            <i :class="category.iconClass"></i>
                            {{ category.label }}
                        </a>
                    </template>
                </Swiper>
            </div>

            <div class="gap-4 my-3 d-flex flex-col justify-content-center" v-if="width >= 768">
                <a class="landing-icon p-2 gap-2 cursor-pointer rounded-3" v-for="category in categories"
                    v-load-page="category.route" v-ripple>
                    <i :class="category.iconClass"></i>
                    {{ category.label }}
                </a>
            </div>
        </div>

        <!-- Popular medications section -->
        <div class="d-flex justify-content-between align-items-center">
            <p class="m-0 fw-medium">Popular medications right now</p>
            <p class="m-0 fw-medium text-decoration-underline cursor-pointer" v-load-page="'/medications'">See all</p>
        </div>

        <CardsContainer :url="'/helper/getLandingPageData'" :parent="'medications'" :page="'basic'" is-swiper />
    </div>
</template>

<script setup>
import Dropdown from 'bootstrap/js/dist/dropdown';
import NavButtons from '@/components/NavButtons.vue';
import Swiper from "../components/Swiper.vue";
import Search from '../components/Search/Index.vue';
import { useWindowSize } from "@vueuse/core";
import { categories } from "../components/nav/navitems";
import CardsContainer from '@/components/Card/CardsContainer.vue';

const { width } = useWindowSize();

</script>

<style lang="scss" scoped>
.landing-container-mw {
    max-width: 900px;
}

.landing-title {
    line-height: 1.25;
    font-weight: 400;
    font-size: 2em;
}

@media (min-width: 576px) and (max-width: 849px) {
    .landing-title {
        line-height: 1.25;
        font-weight: 400;
        font-size: 2.5em;
    }
}

@media (min-width: 850px) and (max-width: 1200px) {
    .landing-title {
        line-height: 1.25;
        font-weight: 400;
        font-size: 2.8em;
    }
}

@media (min-width: 1201px) {
    .landing-title {
        line-height: 1.25;
        font-weight: 400;
        font-size: 3em;
    }
}

@media (min-width: 1500px) {
    .landing-title {
        line-height: 1.25;
        font-weight: 400;
        font-size: 3.8em;
    }
}
</style>